import { resignGame } from '@/realtime/game-room-actions';

const useResignGame = () => {
  const resign = () => {
    console.log('resignGame');
    resignGame().catch(() => {});
  };

  return resign;
};

export default useResignGame;
